// extracted by mini-css-extract-plugin
module.exports = {"contact":"style-module--contact--35rPy","contactText":"style-module--contactText--2bWO9","mail":"style-module--mail--3T2P2","mailLink":"style-module--mailLink--bCOZa"};